import React, { FunctionComponent } from 'react';
import { Button } from '@havenengineering/module-shared-owners-ui/dist/components/Button';

import { useRuntimeConfig } from '../../hooks/useRuntimeConfig';
import styles from './NoActivities.module.scss';

export const NoActivities: FunctionComponent = () => {
  const { PUBLIC_ACTIVITIES_APP_URL } = useRuntimeConfig();
  return (
    <div className={styles.noUpcomingContainer}>
      <span className="owners-body">No upcoming bookings</span>
      <a href={`${PUBLIC_ACTIVITIES_APP_URL}/activity-list`}>
        <Button className={styles.bookButton} variant="outlined">
          Book now
        </Button>
      </a>
    </div>
  );
};
